<p class="intro-text">
  Submissions will be allocated to reviewers automatically and move to 'In progress'. You can edit allocations until the
  batch is committed.
</p>
<p class="intro-text">Please enter the number of submissions you want to allocate and the review deadline
for this batch. </p>

<div class="row">
  <div class="col-md-6">
    <div class="form-group">
      <label>Number of revalidation submissions</label>
      <section>
        <input type="number" [(ngModel)]="cohortSize" [min]="0" class="form-control" #cohort="ngModel"/>
        <app-collapsible [trigger]="cohortSize==='' || (cohort.touched && cohort.errors?.required)">
          <p class="form-error">
            please enter no.of revalidation submissions
          </p>
        </app-collapsible>
      </section>
    </div>
  </div>
  <div class="col-md-6">
    <div class="form-group">
      <label>Review deadline</label>
      <section style="width:220px">
        <app-utc-date-picker [(ngModel)]="reviewDeadline">
        </app-utc-date-picker>
        <app-collapsible  [trigger]="reviewDeadline===''">
          <p class="form-error">
            please enter review deadline
          </p>
        </app-collapsible>
      </section>

    </div>
  </div>
</div>


@if (cohortSize) {
  <div class="row form-group"  style="height:120px;margin-left:1px;">
    <div class="col-md-6">
      <div >
        <label class="pb-2">Split no.of pharmacist submissions & pharmacy technician submissions:</label><br/>
        <section>
          <mat-radio-group [(ngModel)]="searchBy" (ngModelChange)="setFocus()">
            <mat-radio-button [value]="ReviewAllocationSplitType.Default">Default</mat-radio-button>
            <mat-radio-button [value]="ReviewAllocationSplitType.Absolute">By Number</mat-radio-button>
            <mat-radio-button [value]="ReviewAllocationSplitType.Percentage">By Percentage (%)</mat-radio-button>
          </mat-radio-group>
        </section>
      </div>
    </div>
    <div class="col-md-6">
      @if (inputByNumber) {
        <div class="row">
          <div class="col-md-6" >
            <label class="pb-2">Enter no.of pharmacist submissions</label>
            <section>
              <input type="number" #noofPharmacistsByNumber="ngModel" [(ngModel)]="PharmacistAllocation"
                class="form-control" [min]="0" [max]="cohortSize" required/>
              </section>
              <app-collapsible  [trigger]="inputByNumber && (noofPharmacistsByNumber.touched && noofPharmacistsByNumber.errors?.required)">
                <p class="form-error">
                  please enter a value
                </p>
              </app-collapsible>
            </div>
            <div class="col-md-6">
              <label class="pb-2">Enter no.of PT submissions</label>
              <section>
                <input type="number" #noofTechniciansByNumber="ngModel" [(ngModel)]="TechnicianAllocation" class="form-control"
                  [min]="0" [max]="cohortSize" required/>
                </section>
                <app-collapsible [trigger]="inputByNumber && (noofTechniciansByNumber.touched && noofTechniciansByNumber.errors?.required)">
                  <p class="form-error">
                    please enter no.of pharmacy technicians
                  </p>
                </app-collapsible>
              </div>
              <div class="pl-2">
                <app-collapsible [trigger]="(PharmacistAllocation > cohortSize) || (TechnicianAllocation > cohortSize)">
                  <p class="form-error pl-4">
                    please enter number less than no.of revalidation submissions
                  </p>
                </app-collapsible>
                <!--<app-collapsible  [trigger]="(inputByNumber && NumberOfRegistrantsAlloted) && (PharmacistAllocation && TechnicianAllocation)">
                <p class="form-error">
                  please enter number which is less than or equal to no.of revalidation submissions in total
                </p>
              </app-collapsible>-->
              <app-collapsible  [trigger]="(NumberOfRegistrantsLesserThanAllocated)">
                <p class="form-error pl-4">
                  please enter numbers which must be equal to total no.of revalidations
                </p>
              </app-collapsible>
            </div>
          </div>
        }
        @if (inputByPercentage) {
          <div class="row">
            <div class="col-md-12">
              <div class="pb-2">
                <label>Select Pharmacist submissions: <b>{{PharmacistAllocation + '%'}}</b></label
                >&nbsp;
                <label style="float: right;">Select Pharmacist Technicians: <b>{{TechnicianAllocation + '%'}}</b></label
              > </div>
              <section class="sliderMenu">
                <mat-slider class="mat-slider"
                  #gridsize
                  step="1"
                  min="0"
                  max="100"
                #ngSlider><input matSliderThumb [value]="PharmacistAllocation" (change)="updateSetting({source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value})" #ngSliderThumb="matSliderThumb" /></mat-slider>
              </section>
            </div>
            <app-collapsible  [trigger]="inputByPercentage && (PharmacistAllocation.value==='')">
              <p class="form-error">
                please select no.of submissions in percentage
              </p>
            </app-collapsible>
          </div>
        }
      </div>
    </div>
  }

<button (click)="generate()" [disabled]="generating || !cohortSize || !reviewDeadline || NumberOfRegistrantsAlloted 
|| (inputByNumber && NumberOfRegistrantsLesserThanAllocated) || NumberOfRegistrantsAllotedByPercent" class="mt-4 btn btn-lg btn-block btn-primary">
    @if (!generating) {
      <span>
        Allocate to reviewers
      </span>
    }
    @if (generating) {
      <span style="display:flex;align-items:center">
        <div style="flex-grow:1"></div>
        <app-spinner [tiny]="true" [light]="true"></app-spinner>&nbsp;&nbsp;Allocating to reviewers...
        <div style="flex-grow:1"></div>
      </span>
    }

  </button>
  <div style="padding-left: 20px;">
    <app-collapsible [trigger]="noResults">
      <p class="form-error">
        No Professional Pharmacist or Pharmacy Technician Reviewers available.
      </p>
    </app-collapsible>
  </div>